import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit, OnChanges {

  @Input() page: number = 1;
  @Input() pages: number = 1;
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  pageNumbers: Array<number> = [];

  constructor() {

  }

  ngOnInit() {
    this.updatePageNumbers();
  }

  ngOnChanges() {
    this.updatePageNumbers();
  }

  selectPage(page: number) {
    this.pageChange.emit(page);
  }

  private updatePageNumbers() {
    this.pageNumbers = Array<number>();

    if (this.pages > 0) {
      var startingPage = (this.page - (this.page % 4)) + 1;
      if (startingPage > this.page) {
        startingPage = this.page;
      }
      var endingPage = startingPage + 4;

      if (endingPage > this.pages) {
        endingPage = this.pages;
      }

      for (var i = startingPage; i <= endingPage; i++) {
        this.pageNumbers.push(i);
      }
    }
  }

}
